import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-avatar-group',
	templateUrl:'./WaAvatarGroupPage.html',
	styles: [],
	styleUrls:['./WaAvatarGroupPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaAvatarGroupPage
{
	mdContent_274 = `\`\`\`java
import com.jwebmp.webawesome.components.avatar.WaAvatarGroup;
\`\`\``;
}
